<template>
  <div class="upload">
    <el-upload
      action=""
      class="upload-demo"
      :auto-upload="false"
      :show-file-list="true"
      :http-request="() => {}"
      :on-change="onFileChanged"
      :on-remove="onFileRemove"
      :file-list="fileList"
      :multiple="true"
    >
      <el-button
        size="small"
        type="primary"
      >点击上传</el-button>
    </el-upload>
    <!-- <el-upload
        class="upload-demo"
        action="/YuanHe/Work/WorkFileUploadStream"
        :show-file-list="false"
        multiple>
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload> -->
  </div>
</template>

<script>
import systemService from "@/apis/system/index.js";

export default {
  name: "upload",
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    onFileChanged(file, fileList) {
      // 安卓手机上传文件

      this.$nextTick(() => {
        file.status = "uploading";
      });
      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        const base64 = e.target.result;
        console.log(base64);
      };
      this.fileList = fileList;
      const formData = new FormData();
      console.log(file.raw);
      formData.append("file", file.raw);
      const query = {
        file_type: "work",
        file_name: file.name,
        file_ext: file.name.split(".").pop(),
        file_size: file.size,
      };

      const onUploadProgress = (progressEvent) => {
        const percentage =
          (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
        file.percentage = percentage;
        this.$forceUpdate();
      };
      this.fileChange(fileList);

      systemService.upload(formData, query, onUploadProgress).then((res) => {
        file.file_id = res.file_id;
        file.status = "success";
        this.fileChange(fileList);
      });
    },
    onFileRemove(file, fileList) {
      this.fileList = fileList;
      this.fileChange(fileList);
    },
    fileChange(fileList) {
      this.$emit("change", fileList);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>